//直播公开课
const recentMoreLiveCourse = () => import('@/pages/arkHome/recentMoreLiveCourse.vue');
const newRecentMoreLiveCourse = () => import('@/pages/commonExamYear/recentMoreLiveCourse.vue');

export default [
  {
    path: '/recentMoreLiveCourse',
    component: recentMoreLiveCourse,
    meta: {
      title: '直播公开课',
    },
  },
  {
    path: '/newRecentMoreLiveCourse',
    component: newRecentMoreLiveCourse,
    meta: {
      title: '直播公开课',
    },
  },

];
